import React, { Component } from "react";
import DocumentTitle from "react-document-title";
import BsyAppPane from "../BsyAppPane";
import BsyDashboardMenu from "../dashboard/BsyDashboardMenu";
import "./index.css"
import BsyVirtualReleaseManagement from "../BsyVirtualReleaseManagement";
import { withRouter } from "react-router-dom";

class BsyStandardAppPane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMenu: "groupid" in props.match.params ? "management" :
        "type" in props.match.params && props.match.params.type === "release" ? "release" :
          "management",
    }
  }

  componentDidMount() {

  }

  render() {
    const { activeMenu } = this.state;
    return (

      <div className="BsyStandardAppPane">
        <BsyDashboardMenu
          hasDesign={false}
          isStandard={true}
          leftTitle={() => {
            return <div></div>
          }}
          dashboardMenuCenterMenu={() => {
            return <div className="standard-center">
              <div className={`dashboard-design management ${activeMenu === "management" ? "active" : ""}`}
                title={React.language('project.create')}
                onClick={() => {
                  this.setState({
                    activeMenu: "management"
                  })
                  this.props.history.push(`${window.rootDirectroy}/team/standard/management`)
                }}
              >
                {/* <i className="icon-bsy-object-management"></i> */}
                <span>{React.language('project.create')}</span>
              </div>
              <div className={`dashboard-design release ${activeMenu !== "management" ? "active" : ""}`}
                title={React.language('project.management')}
                onClick={() => {
                  this.setState({
                    activeMenu: "release"
                  })
                  this.props.history.push(`${window.rootDirectroy}/team/standard/release`)
                }}
              >
                {/* <i className="icon-bsy-object-management"></i> */}
                <span>{React.language('project.management')}</span>
              </div>
            </div>
          }}
        />
        {
          activeMenu !== "management" ?
            <BsyVirtualReleaseManagement />
            : <div className={"content-pane"}  >
              <DocumentTitle title={`${React.language("project.management")} - ${React.language("standard.application")}`}>
                <BsyAppPane
                  isStandard={true}
                  title={React.language("standard.application")}
                  // onSelectApp={this.selectApp}
                  apps={[]}
                  dockItem={[]}
                />
              </DocumentTitle>
            </div>
        }

      </div>

    )
  }
}

export default withRouter(BsyStandardAppPane);